<button type="button" class="btn btn-primary floating-button" id="floatingButton" data-toggle="modal" data-target="#faqChatbotModal">
    <img src="../../assets/images/icon-bot.svg" alt="Chatbot Icon" class="floating-button-icon">
</button>

<div class="modal fade" id="faqChatbotModal" tabindex="-1" aria-labelledby="faqChatbotModalLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="faqChatbotModalLabel">FAQ Chatbot</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="iframe-container">
                    <iframe src="https://agrani-chatbot.celloscope.net/#/chatbotPage" allow="microphone" frameborder="0" width="100%" height="100%"></iframe>
                </div>
            </div>
        </div>
    </div>
</div>